import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-queue-alerts',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './queue-alerts.component.html',
  styleUrl: './queue-alerts.component.css'
})
export class QueueAlertsComponent {

}
